import router from '@/router'
import store from '@/store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { depthTraversal } from '@/utils/tree'

NProgress.configure({ showSpinner: false })

let whiteList = ['/login', '/404', '/test']

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  let hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      // let hasGetPermission = store.getters.isGetPermission
      // if (hasGetPermission) {
        let menus = [...whiteList]
        depthTraversal(
          store.getters.menus,
          (item) => {
            menus.push(item.path)
          },
          'children'
        )
        let to_path = to.path
        if (to_path.charAt(to_path.length - 1) === '/') {
          to_path = to_path.substring(0, to_path.length - 1)
        }
        if (menus.includes(to_path)) {
          next()
        } else {
          next({ path: '/404' })
        }
      // } else {
        // try {
        //   await store.dispatch('user/getUserPerissions')
        //   next({ ...to, replace: true })
        // } catch (error) {
        //   await store.dispatch('user/resetToken')
        //   Message.error(error || 'Has Error')
        //   next({ path: `/login?redirect=${to.path}` })
        //   NProgress.done()
        // }
      // }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next({ path: `/login?redirect=${to.path}` })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
